import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type GetCollaborationTokenOperation = 'GetCollaborationTokenV3'

export type GetCollaborationTokenV3ResponseData = OpalApiResponseDocument<
  GetCollaborationTokenOperation,
  200
>

type GetCollaborationTokenV3RequestParams =
  OpalApiRequestParams<GetCollaborationTokenOperation>

export async function getCollaborationToken(
  params: GetCollaborationTokenV3RequestParams
): Promise<GetCollaborationTokenV3ResponseData> {
  const url = new URL(
    `/rich_texts/v3/get_collaboration_token`,
    window.location.origin
  )

  url.search = queryString({
    document_id: params.query.document_id.join(','),
    ...(params.query.permission && { permission: params.query.permission }),
  })

  return HttpClient()
    .get<GetCollaborationTokenV3ResponseData>(url.toString())
    .then((res) => res.data)
}
